const KSUID = require('ksuid');

export const getRandomIDSync = (): string => KSUID.randomSync().string;
